export const ContenedorPageTemplate = ({
  children,
  objetos,
  dirIcono = "",
  titulo = "",
  onclick,
  fondo = true,
  mostrarBoton = true, // 👈 nuevo: control para mostrar u ocultar el botón
}) => {
  return (
    <main
      className={`${fondo ? "bg-[#F5F8FF]" : "bg-[#F5F8FF]"} overflow-y-hidden p-2 h-full`}
    >
      <div
        className={`h-full ${fondo ? "bg-[#F5F8FF]" : "bg-[#F5F8FF]"} rounded-lg p-4`}
      >
        <div className="flex items-center mb-4 gap-2 justify-between">
          <div className="flex gap-2 mb-3 text-black">
            {/* {dirIcono && (
              <img src={dirIcono} alt="iconoEst" className="logo w-40" />
            )} */}
            <h1 className="text-3xl">{titulo}</h1>
          </div>

          {mostrarBoton && onclick && ( // ✅ ahora puedes controlar su visibilidad
            <button
              onClick={onclick}
              className="bg-theme-yellow hover:bg-yellow-500 text-white font-semibold px-6 py-2 rounded shadow"
            >
              + Nuevo
            </button>
          )}
        </div>

        {objetos === null ? (
          <section className="absolute top-1/2 translate-x-1/2 right-1/2">
            <div className="lds-ellipsis">
              <div></div>
              <div></div>
              <div></div>
            </div>
          </section>
        ) : (
          children
        )}
      </div>
    </main>
  );
};
